import { OnInit } from '@angular/core';
import { OptimizerServiceService } from '../optimizer-service.service';
import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Options } from 'ng5-slider';
import {SlimLoadingBarService} from '@cime/ngx-slim-loading-bar';
import { ToastrService } from 'ngx-toastr';
import { $ } from 'protractor';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  regData = {"passwd":"","investment":"","ror":"","sd":""};
  current_need:string;
  current_have:string;
  current_alloc:any;

  constructor(private http: HttpClient,private slimLoadingBarService: SlimLoadingBarService,
    private toastr: ToastrService,private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any,
    private router: Router,private route: ActivatedRoute,
    public optimizerService: OptimizerServiceService){}

  ngOnInit() {
    localStorage.clear();
    /** Check if QueryString parameters are passed. If yes load the parameters.*/
    var investment = this.route.snapshot.queryParamMap.get("investment");
    var ror = this.route.snapshot.queryParamMap.get("ror");
    var sd = this.route.snapshot.queryParamMap.get("sd");
    this.current_need = this.route.snapshot.queryParamMap.get("need");
    localStorage.setItem("Current_Need", this.current_need)
    this.current_have = this.route.snapshot.queryParamMap.get("have");
    localStorage.setItem("Current_Have", this.current_have)

    var uuid=this.route.snapshot.queryParamMap.get("uuid");
    localStorage.setItem('uuid',uuid);

    var beta=this.route.snapshot.queryParamMap.get("beta");
    localStorage.setItem('beta_avg',beta);

    if(investment && investment.length>0 && ror && ror.length>0){
      this.regData.investment = investment;
      this.regData.ror = ror;
      this.regData.sd = sd;
    }
  }

  doLogin(){
    this.startLoading();
    return this.http.post(
      this.optimizerService.getAuthenticationEndpointURL(),
      {
        "passwd":this.regData.passwd
      }).subscribe((data:any) => {
        this.completeLoading();
        var authStatus = data.authentication;
        if(authStatus == "SUCCESS"){
          // on success forward to optimizer
          var params = {};
          var investment = this.regData.investment;
          var ror = this.regData.ror;
          var sd = this.regData.sd;
          // var need = this.current_need;
          // var have=this.current_have;
          if(investment && investment.length>0 && ror && ror.length>0){
            params = {"investment":investment,"ror":ror,"sd":sd};
            this.router.navigate(['/optimizer'], { queryParams: params});
          }else{
            this.router.navigate(['/optimizer']);
          }
        }else{
          this.toastr.error('Authentication ERROR! Invalid Password!!');
        }
      },(error:any) => {
        this.completeLoading();
        if(error.status == 500){
          this.toastr.error('Server ERROR! Please try again later!!');
        }else{
          this.toastr.error('Network ERROR! Kindly check your network and try again!');
        }
      })

  }

  startLoading() {
    this.slimLoadingBarService.start(() => {
        console.log('Loading complete');
    });
  }

  stopLoading() {
    this.slimLoadingBarService.stop();
  }

  completeLoading() {
    this.slimLoadingBarService.complete();
  }

}
